import { render, staticRenderFns } from "./BullettinModal.vue?vue&type=template&id=8700c25a&"
import script from "./BullettinModal.vue?vue&type=script&lang=js&"
export * from "./BullettinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports